import { useFormContext } from 'react-hook-form';
import { v4 as uuidv4 } from 'uuid';
import RootInput from 'components/Input/RootInput/RootInput';
import { type RootInputProps } from 'components/Input/RootInput/types';
import { CITY_MAX_LENGTH } from './config';

type Props = Pick<RootInputProps, 'name' | 'label' | 'required' | 'containerClassName'>;

const CityInput = (props: Props) => {
  const { name, label, required, containerClassName } = props;

  const { control, clearErrors } = useFormContext();

  return (
    <RootInput
      maxLength={CITY_MAX_LENGTH}
      name={name}
      control={control}
      label={label}
      clearErrors={clearErrors}
      autoComplete={uuidv4()}
      containerClassName={containerClassName}
      required={required}
    />
  );
};

export default CityInput;
